import React, { Component } from "react";
import { connect } from "react-redux";
import { Async } from "react-select";
import * as selectors from "../../reducers";
import "react-select/dist/react-select.css";
import "./search.scss";
import {
    setActiveFeature,
    setActiveProject,
    setSearchedLocation,
} from "../../actions/ui";
import { projectShape } from "../../modules/project";
import pointInPolygon from "@turf/boolean-point-in-polygon";
import turfPoint from "turf-point";
import PropTypes from "prop-types";
import { getGeoJSON } from "../../actions/data";
import styles from "./search.module.scss";

const getMatchedProjects = (text, projects) => {
    return new Promise((res, rej) => {
        const matchedProjects = projects
            .filter(d =>
                d["Project Title"].toLowerCase().includes(text.toLowerCase())
            )
            .map(d => ({
                value: d,
                label: d["Project Title"],
            }));
        res(matchedProjects);
    });
};
const getMatchedElectorates = (text, features, nameSelector) => {
    return new Promise((res, rej) => {
        const matchedProjects = features
            .filter(d =>
                nameSelector(d)
                    .toLowerCase()
                    .includes(text.toLowerCase())
            )
            .map(d => ({
                value: d,
                label: nameSelector(d),
            }));
        res(matchedProjects);
    });
};

class GeoSearchInput extends Component {
    constructor() {
        super();
        this.getOptions = this.getOptions.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
    }
    componentDidMount() {
        const { geometryConfig } = this.props;
        this.props.getGeoJSON(
            geometryConfig.geojsonUrl,
            geometryConfig.topologyObjectsName
        );
    }

    handleOnChange(d) {
        if (!d) {
            this.props.setActiveFeature(undefined);
            return;
        }
        if (d.value.geometry) {
            this.props.setActiveFeature(d.value);
            return;
        }
        const optionPos = [d.value.Longitude, d.value.Latitude];
        const activeFeature = this.props.geojson.features.find(feature => {
            return pointInPolygon(turfPoint(optionPos), feature);
        });

        this.props.setActiveFeature(activeFeature);

        this.props.setActiveProject(d.value);
    }

    getOptions(text) {
        if (!text || text.length < 2) {
            return Promise.resolve({ options: [] });
        }
        const { geometryConfig, geojson } = this.props;

        const projectsP = getMatchedProjects(text, this.props.projects);
        const electoratesP = getMatchedElectorates(
            text,
            geojson.features,
            geometryConfig.nameSelector
        );
        return Promise.all([projectsP, electoratesP])
            .then(([projects, electorates]) => {
                return {
                    options: projects.concat(electorates),
                };
            })
            .catch(err => console.log(err));
    }
    optionsRenderer(option) {
        if (!option) return null;

        const label = option.value.geometry ? "Electorate" : "Project";
        return (
            <React.Fragment>
                <p style={{ margin: "5px 0" }}>
                    <strong className={styles.bold}>{label}:</strong>{" "}
                    {option.label}
                    {option.value.geometry ? " Electorate" : ""}
                </p>
            </React.Fragment>
        );
    }
    makeOption(value) {
        if (!value) return null;
        return {
            label:
                this.props.geometryConfig.nameSelector(value) + " Electorate",
            value,
        };
    }
    renderInput() {
        const { activeFeature } = this.props;
        return (
            <Async
                loadOptions={this.getOptions}
                value={this.makeOption(activeFeature)}
                loading={Boolean(!this.props.geojson)}
                onChange={this.handleOnChange}
                optionRenderer={this.optionsRenderer}
                filterOptions={o => o}
                isClearable={true}
                placeholder={"Search project or electorate"}
            />
        );
    }

    render() {
        if (!this.props.geojson) return null;
        return (
            <div className="Search">
                {this.renderInput()}
                <img
                    className={styles.searchIcon}
                    src={`${process.env.PUBLIC_URL}/img/search-icon.svg`}
                    alt="search icon black"
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    projects: selectors.selectFilteredProjects(state),
    geojson: selectors.selectGeoJSON(state),
    activeFeature: selectors.selectActiveFeature(state),
});
const mapDispatchToProps = {
    setActiveFeature,
    setSearchedLocation,
    setActiveProject,
    getGeoJSON,
};

GeoSearchInput.propTypes = {
    setActiveFeature: PropTypes.func.isRequired,
    setActiveProject: PropTypes.func.isRequired,
    getGeoJSON: PropTypes.func.isRequired,
    projects: PropTypes.arrayOf(PropTypes.shape(projectShape)),
    geojson: PropTypes.object,
    activeFeature: PropTypes.object,
    geometryConfig: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(GeoSearchInput);



// WEBPACK FOOTER //
// ./src/components/search/search.js